import type { ViewField } from "../types";

export function adaptCanvasViewFields(fields: ViewField[]): ViewField[] {
  return fields.map((field) => ({
    ...field,
    visible: field.is_visible ?? field.visible ?? true,
    editable: field.is_editable ?? field.editable ?? false,
    display_name: field.display_label ?? field.display_name,
    alias: field.alias ?? field.column?.column_name,
  }));
}
